export const getAmountWithSymbol = (values) => {
  const { currency, amount } = values

  if (!currency) return ''

  const locale = currency === 'EUR' ? 'de-DE' : 'en-US'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0)
}
